import { render, staticRenderFns } from "./AppointmentCategoryData.vue?vue&type=template&id=406da87a"
import script from "./AppointmentCategoryData.vue?vue&type=script&lang=ts"
export * from "./AppointmentCategoryData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports